<template>
  <div class="select">
    <div
      class="select-field select-field_floating-2 "
      :class="{ 'select-active': dropdawn }"
    >
      <div
        class="select-field__input"
        :class="{ 'select-field__input-active': dropdawn }"
      >
        {{ innerValue.title }}
      </div>
      <div
        class="select-field__label"
        :class="{ 'select-field__label-top': innerValue }"
        for="email"
      >
        Куда выводить
      </div>
      <div
        class="triangle"
        :class="{ 'triangle-active': dropdawn }"
        @click="dropdawn = !dropdawn"
      >
        <svg
          width="14"
          height="7"
          viewBox="0 0 14 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0L14 0L8.051 5.946L8.05593 5.95L7.00516 7L0 0Z"
            :fill="dropdawn ? '#F47139' : 'white'"
          />
        </svg>
      </div>
    </div>
    <div class="options-drop" :class="{ 'options-drop-active': dropdawn }">
      <div class="search">
        <div class="text-field text-field_floating-3">
          <div class="search-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.11109 15.2222C12.04 15.2222 15.2222 12.0382 15.2222 8.11109C15.2222 4.18399 12.04 1 8.11109 1C4.18221 1 1 4.18399 1 8.11109C1 12.0382 4.18221 15.2222 8.11109 15.2222Z"
                stroke="#828282"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9999 16.9999L13.1333 13.1333"
                stroke="#828282"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <input
            class="text-field__input"
            type="text"
            name="search"
            placeholder="Поиск"
            v-model="search"
          />
        </div>
      </div>
      <div class="line"></div>
      <div class="options">
        <p
          class="option"
          v-for="option in filterOption"
          @click="
            innerValue = option;
            dropdawn = false;
          "
        >
          {{ option.title }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { VueMaskDirective } from "v-mask";
export default {
  name: "app-input",
  props: {
    options: {
      type: Array,
      required: true
    },
    bg: {
      type: String,
      default: "#191b1f"
    },
    pass: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    vid: {
      type: String,
      default: undefined
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    label: {
      type: String,
      required: true
    },
    mask: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      innerValue: "",
      focused: false,
      innderValue: null,
      eye: false,
      dropdawn: false,
      search: null
    };
  },
  watch: {
    innerValue(value) {
      this.$emit("updateValue", value);
    },
    value: {
      handler: function(val) {
        if (val !== this.innerValue) {
          if (this.type == "number") {
            this.innerValue = String(val).replace(".", ",");
          }
          this.innerValue = val;
        }
      }
    }
  },
  computed: {
    filterOption() {
      if (this.search == "" || this.search == null) return this.options;
      return this.options.filter(item => {
        return item.title.toLowerCase().indexOf(this.search) > -1;
      });
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {},
  directives: {
    mask: VueMaskDirective
  }
};
</script>
<style scoped>
.triangle {
  position: absolute;
  top: 10px;
  right: 15px;
  transform: rotate(0deg);
  transition: transform var(--duration) ease;
}
.triangle-active {
  transform: rotate(180deg);
}
.options-drop {
  overflow-y: hidden;
  max-height: 200px;
  height: 0vh;
  background-color: #272c35;
  transition: height var(--duration) ease;
}
.options-drop-active {
  height: 100vh;
}
.options {
  max-height: 130px;
  height: 100%;
  overflow-y: scroll;
}
.option {
  cursor: pointer;
}
.option:not(:last-child) {
  margin-bottom: 8px;
}
.option:hover {
  color: var(--primary-v);
}
.option-active {
  color: var(--primary-v);
  font-weight: 600;
}
.line {
  margin-top: 0;
}
/* text field */
.select-field {
  margin-bottom: 24px;
}

.select-field__label {
  display: block;
  margin-bottom: 0.25rem;
}

.select-field__input {
  display: block;
  width: 100%;
  height: 48px;
  padding: 0.375rem 0.75rem;
  padding-right: 16px;
  font-family: inherit;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: #fff;
  background-clip: padding-box;
  border: 1px solid #828282;
  border-radius: 12px;
  /* transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.select-active > .select-field__input {
  border-color: var(--primary-v);
}
/* with floating label */
.select-field_floating-2 {
  position: relative;
}

.select-field_floating-2 .select-field__input {
  height: calc(2.5rem + 2px);
  padding: 0.5rem 0.75rem;
  padding-right: 26px;
}
.select-field_floating-2 .select-field__input-active {
  color: var(--primary-v);
}

.select-field_floating-2 .select-field__label {
  position: absolute;
  top: 50%;
  left: 0.3125rem;
  display: flex;
  transform: translateY(-50%);
  pointer-events: none;
  border: none;
  border-radius: 12px;
  color: #757575;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 12px;
  background-color: #272c35;
  transition: top 0.1s ease-in-out, scale 0.1s ease-in-out;
}

.select-field_floating-2 .select-field__label-top {
  top: 0;
  left: 12px;

  font-size: 11px;
}

.select-field {
  position: relative;
}

/* text field */
.text-field {
  margin-bottom: 1rem;
}

.text-field__label {
  display: block;
  margin-bottom: 0.25rem;
}

.text-field__input {
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #828282;
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid #bdbdbd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-field__input[type="search"]::-webkit-search-decoration,
.text-field__input[type="search"]::-webkit-search-cancel-button,
.text-field__input[type="search"]::-webkit-search-results-button,
.text-field__input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.text-field__input::placeholder {
  color: #828282;
}

.text-field__input:focus {
  color: #828282;
  background-color: transparent;
  border-color: #bdbdbd;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(158, 158, 158, 0.25);
}

.text-field__input:disabled,
.text-field__input[readonly] {
  background-color: transparent;
  opacity: 1;
}

/* with floating label */
.text-field_floating-3 {
  position: relative;
}

.text-field_floating-3 .text-field__input {
  border: none;
  /* border-bottom: 1px solid #bdbdbd; */
  border-radius: 0;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  height: 40px;
  line-height: 1.25;
  padding: 1rem 0.75rem;
  padding-left: 30px;
  background-color: transparent;
}

.text-field_floating-3 .text-field__input:focus {
  outline: 0;
  /* border-bottom: 1px solid #03a9f4; */
  box-shadow: none;
  background-color: transparent;
}

.text-field_floating-3 .text-field__label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: color 0.15s ease-in-out, transform 0.15s ease-in-out;
}

/* .text-field_floating-3 .text-field__input:focus,
.text-field_floating-3 .text-field__input:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #03a9f4;
}

.text-field_floating-3 .text-field__input:focus ~ .text-field__label,
.text-field_floating-3
  .text-field__input:not(:placeholder-shown)
  ~ .text-field__label {
  transform: scale(0.85) translateY(-0.75rem) translateX(0.15rem);
  color: #03a9f4;
} */
.search-icon {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppSelect.vue